// extracted by mini-css-extract-plugin
export default {"admin":"AdminPage_admin__QSnqL","qr-reader":"AdminPage_qr-reader__iOnb1","attendance-table":"AdminPage_attendance-table__tY7CH","complete-text":"AdminPage_complete-text__gnJjU"};